import React from 'react';
interface ISingleResultRow {
  keyVal?: number;
  results: any[];
  name: string;
  handleHitSelect?: any;
  selectedItems?: any;
  setSelectedItems?: any;
}

const LensRow: React.FC<ISingleResultRow> = ({
  keyVal,
  results,
  handleHitSelect,
  name,
}) => {
  return (
    <div className='screening-results-row' key={keyVal}>
      {/* The 48px leading cell that used to sit here held a checkbox that has
          been commented out for some time, so it rendered as an empty gutter on
          every lens row and forced a matching placeholder cell in LensColumns.
          Both are removed together to keep the header and rows aligned; restore
          them as a pair if lens-level selection comes back. */}
      <div className='screening-results-row-default-cell'>
        <div
          className='screening-results-row-default-cell-inner'
          onClick={() => handleHitSelect(results, name)}
        >
          <div className='screening-results-row-link-cell-text'>{name}</div>
        </div>
      </div>
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          <div className='screening-results-row-default-cell-text'>
            {results?.length}
          </div>
        </div>
      </div>
      <div className='screening-results-row-default-cell'>
        <div className='screening-results-row-default-cell-inner'>
          <span className='screening-badge none'>0</span>
        </div>
      </div>
      {/* <div className='screening-results-row-default-cell' >
        <div className='screening-results-row-default-cell-inner'>
          {
            supplier.status.includes('Barred') ? (
              <span className='screening-badge high'>{supplier.status}</span>
            ) : supplier.status.includes('Medium') ? (
              <span className='screening-badge medium'>{supplier.status}</span>
            ) : supplier.status.includes('Cleared') ? (
              <span className='screening-badge low'>{supplier.status}</span>
            ) : (
              <span className='screening-badge none'>{supplier.status}</span>
            )
          }
        </div>
      </div> */}
    </div>
  );
};

export default LensRow;
